import * as React from "react";
import { Route } from "react-router-dom";
import SwitchWith404 from "nexia_mobile/components/Routing/SwitchWith404";
import BackboneListener from "nexia_mobile/components/BackboneListener";
import connect from "nexia_mobile/flux_like/store/connect";
import { history } from "nexia_mobile/history";
import BuildingsPage from "nexia_mobile/components/Pages/BuildingsPage";
import BuildingEditPage from "nexia_mobile/components/Pages/BuildingEditPage";
import BuildingDetails from "nexia_mobile/components/Details/BuildingDetails";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store from "nexia_mobile/flux_like/store";

class BuildingRoutes extends React.Component {
  render() {
    const { session } = this.props;
    return (
      <BackboneListener listenTo={session} events={["change:locations"]}>
        {() => {
          const locations = session.get("locations");
          locations.each((location) => location.preventDeviceListingView());
          return (
            <BackboneListener
              listenTo={locations}
              events={["add", "remove", "reset", "sort", "sync"]}
              debounceRender
            >
              {() => (
                <SwitchWith404>
                  <Route
                    path="/app/buildings"
                    exact
                    render={() => (
                      <BuildingsPage
                        collection={locations}
                        onNew={() => {
                          Dispatch("RUN_PROMISE_WITH_SPINNER", () => {
                            return locations
                              .getChildSchema()
                              .then((editSchema) => {
                                history.push("/app/buildings/edit", {
                                  editSchema,
                                });
                              });
                          });
                        }}
                      />
                    )}
                  />
                  <Route
                    path="/app/buildings/details"
                    exact
                    render={({ location }) => {
                      const { building } = location.state;

                      return (
                        <BackboneListener
                          listenTo={building}
                          events={["change"]}
                        >
                          {() => (
                            <BuildingDetails
                              model={building}
                              openBuildingEdit={(editSchema) => {
                                history.push("/app/buildings/edit", {
                                  editSchema,
                                });
                              }}
                              onDelete={() => {
                                Dispatch("RUN_PROMISE_WITH_SPINNER", () => {
                                  return new Promise((resolve) => {
                                    Dispatch("POPULATE_SESSION");
                                    Store.session
                                      .get("locations")
                                      .once("remove", resolve);
                                  }).then(() => history.goBack());
                                });
                              }}
                            />
                          )}
                        </BackboneListener>
                      );
                    }}
                  />
                  <Route
                    path="/app/buildings/edit"
                    exact
                    render={({ location }) => {
                      const { editSchema } = location.state;
                      return (
                        <BuildingEditPage
                          model={editSchema}
                          onCommit={() => {
                            Dispatch("RUN_PROMISE_WITH_SPINNER", () => {
                              return Promise.resolve(
                                Dispatch("POPULATE_SESSION")
                              ).then(history.goBack());
                            });
                          }}
                        />
                      );
                    }}
                  />
                </SwitchWith404>
              )}
            </BackboneListener>
          );
        }}
      </BackboneListener>
    );
  }
}

export default connect({ session: "session" }, BuildingRoutes);



// WEBPACK FOOTER //
// ./src/components/Routing/BuildingRoutes.jsx